class TokenExpiredError extends Error {
  constructor(message, ...args) {
    const msg = 'token is expired';

    super(message || msg, ...args);
    this.name = 'TokenExpiredError';

    Error.captureStackTrace(this, TokenExpiredError);
  }
}

export default TokenExpiredError;
